module.exports = __webpack_public_path__ + "static/fonts/iconfont.fe4a85e.ttf";